import * as angular from 'angular';
import { Observable } from 'rxjs';

import { ReportBuilderStore } from '@mode/reports/sandbox/contract';
import { LayoutSelectors } from '~/modules/embed-report/domain/layout/embed-layout.selectors';
import { MixableBaseController } from '../../../common/component';
import { VizTypes } from '../../../common/types';

class TextBlockContainerController extends MixableBaseController {
  static $inject = ['RxStoreService', '$window'];

  id: string;
  token: string;
  vizType: VizTypes;

  textContent$: Observable<string>;

  constructor(
    private rxStore: ReportBuilderStore,
    private $window: angular.IWindowService
  ) {
    super();
  }

  $onInit() {
    [this.vizType, this.token] = this.id.split('_') as [VizTypes, string];
    this.textContent$ = this.rxStore.select(LayoutSelectors.createTextContentSelector(this.token));
  }
}

export const ModeTextComponent: angular.IComponentOptions = {
  bindings: {
    id: '@',
  },
  controller: TextBlockContainerController,
  controllerAs: 'ctrl',
  template: `
    <text-block-renderer
      id="{{ ::ctrl.id }}"
      text-content="ctrl.textContent$ | async:this"
      can-edit="false"
    />`,
};
